import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const ItemSKUCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Item SKU",
    cell: (row) => {
      return Array.from(
        new Set(row.items?.map((item) => item.sku).filter(Boolean)) ?? [],
      ).join(", ");
    },
    expandedCsvCell: (row, expansionIndex) => {
      return getExpandedItems(row)?.[expansionIndex]?.sku ?? "";
    },
  };
